// How a segment entered the stream. Absent ⇒ spoken (default); EC never sets it.
export var TranscriptSource;
(function (TranscriptSource) {
    TranscriptSource["Spoken"] = "spoken";
    TranscriptSource["Chat"] = "chat";
    TranscriptSource["Backroom"] = "backroom";
    TranscriptSource["Private"] = "private";
})(TranscriptSource || (TranscriptSource = {}));
/**
 * Direction signalled by WordInlineEditor's commit payload. Tab → Forward,
 * Shift+Tab → Backward, Enter / blur → Stop.
 */
export var WordEditAdvance;
(function (WordEditAdvance) {
    WordEditAdvance["Forward"] = "forward";
    WordEditAdvance["Backward"] = "backward";
    WordEditAdvance["Stop"] = "stop";
})(WordEditAdvance || (WordEditAdvance = {}));
